import type { IAboutUsPayload } from "@model/Aboutus.model";
import aboutus from "Utils/Assets/Images/Aboutus.webp"
export const aboutMock: IAboutUsPayload = {
  intro: {
    title: "We automate everything that should be automatic",
    subtitle:
      "Chimera was created around a simple idea: technology should make life feel easier, not more complicated. " +
      "We design smart automation experiences that quietly support the way people live, work, relax, and move through theirday, turning everyday spaces into places that feel more comfortable, more responsive, and more in tune with theirowners.",
    pills: [
      { label: "Automation with taste" },
      { label: "Speed, safely" },
      { label: "Human-centered" },
    ],
     imageSrc:aboutus,
  },

  vision: {
    title: "Our Vision",
    subtitle:
      "To make modern spaces feel effortless, where comfort, control, and technology come together naturally in thebackground of everyday life.",
    cards: [
      {
        title: "Everyday Comfort, Elevated",
        description:
          "We believe the small moments matter: the right light when you enter a room, the perfect atmosphere in the evening, andthe feeling that your home is ready before you even ask.",
      },
      {
        title: "A Home That Feels in Sync",
        description:
          "Chimera helps your space follow your rhythm. From morning routines to quiet nights, every detail can be shaped tomake life feel smoother, warmer, and more comfortable.",
      },
      {
        title: "Technology That Blends In",
        description:
          "The most beautiful technology is the one you barely notice. It works quietly in the background, giving you more ease,more comfort, and more time for what matters.",
      },
    ],
  },

  whatWeDo: {
    title: "What We Bring Together",
    subtitle:
      "Chimera blends automation, engineering, and software to create smarter spaces and digital products that feel simple,reliable, and beautifully made.",
    items: [
      {
        title: "Smart Living",
        description: "A home that feels ready,responsive, and in sync with yourday.",
        iconKey: "hardware",
      },
      {
        title: "Reliable Technology",
        description: "Hardware and systems built towork quietly in the background.",
        iconKey: "system",
      },
      {
        title: "Custom Software",
        description: "Web apps, mobile apps,dashboards, and platforms builtaround real needs.",
        iconKey: "software",
      },
    ],
  },

  teamGroups: [
    {
      groupName: "Leadership",
      description: "Guiding the vision and keeping quality high.",
      members: [
        {
          name: "Rana Lamia",
          title: "CEO",
          photoUrl: "https://i.pinimg.com/1200x/a0/0d/83/a00d83e9e13a873d1f17efaa714f59c2.jpg",
          summary: "Strategy, hiring, partnerships.",
        },
        {
          name: "Karim S.",
          title: "CTO",
          photoUrl: "https://i.pinimg.com/736x/d9/b6/1a/d9b61a74e0ca7c64d50d27bb42013b4b.jpg",
          summary: "Architecture, security, AI systems.",
        },
         {
          name: "Nour H.",
          title: "Frontend Engineer",
          photoUrl: "https://i.pinimg.com/736x/f6/61/ea/f661ea61616909838a9fbfeda0d2ea14.jpg",
          summary: "React, UX, performance.",
        },
          {
          name: "Rana Lamia",
          title: "CEO",
          photoUrl: "https://i.pinimg.com/1200x/a0/0d/83/a00d83e9e13a873d1f17efaa714f59c2.jpg",
          summary: "Strategy, hiring, partnerships.",
        },
        {
          name: "Karim S.",
          title: "CTO",
          photoUrl: "https://i.pinimg.com/736x/d9/b6/1a/d9b61a74e0ca7c64d50d27bb42013b4b.jpg",
          summary: "Architecture, security, AI systems.",
        },
         {
          name: "Nour H.",
          title: "Frontend Engineer",
          photoUrl: "https://i.pinimg.com/736x/f6/61/ea/f661ea61616909838a9fbfeda0d2ea14.jpg",
          summary: "React, UX, performance.",
        },
         {
          name: "Jad A.",
          title: "Backend Engineer",
          photoUrl: "https://i.pinimg.com/736x/5d/ea/c3/5deac3296927862d06e73661c1bb7720.jpg",
          summary: "APIs, data, reliability.",
        },
      ],
    },
    {
      groupName: "Engineering",
      description: "Full-stack builders turning ideas into products.",
      members: [
        {
          name: "Nour H.",
          title: "Frontend Engineer",
          photoUrl: "https://i.pinimg.com/736x/f6/61/ea/f661ea61616909838a9fbfeda0d2ea14.jpg",
          summary: "React, UX, performance.",
        },
        {
          name: "Jad A.",
          title: "Backend Engineer",
          photoUrl: "https://i.pinimg.com/736x/5d/ea/c3/5deac3296927862d06e73661c1bb7720.jpg",
          summary: "APIs, data, reliability.",
        },
         
      ],

    },
    
  ],
};
